const isGoogleAppointmentsLandingPage = () =>
  window.location.href.includes("mg_permanent=true");

export default isGoogleAppointmentsLandingPage;
